import { connect } from 'react-redux';
import { getFormValues, reset, isDirty, isValid, getFormSyncErrors, touch, untouch } from 'redux-form';
import { Dispatch, bindActionCreators } from 'redux';
import DashboardDetails from './DashboardDetails';
import { actions as uiActions } from 'ducks/ui';
import { actions as operationActions, selectors as operationSelectors } from 'ducks/uiOperations';
import { IApplicationState } from 'ducks/reducers';
import { selectors as dashboardMaintenanceSelectors, actions as dashboardMaintenanceActions } from 'ducks/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';
import { selectors as formSelectors } from 'ducks/form';
import { selectors as staffSelectors } from 'ducks/staff';

const params = new URLSearchParams(location.search);
export const FORM_NAME = 'DashboardDetailsForm';

const mapStateToProps = (state: IApplicationState) => ({
    selectedDashboardId: dashboardMaintenanceSelectors.selected(state)?.DashboardId ?? params.get('DashboardId'),
    dirty: isDirty(FORM_NAME)(state),
    formValues: getFormValues(FORM_NAME)(state),
    operationMode: operationSelectors.operationMode(state),
    isValid: isValid(FORM_NAME)(state),
    formSyncErrors: getFormSyncErrors(FORM_NAME)(state),
    formAsyncErrors: formSelectors.getFormAsyncErrors(FORM_NAME)(state),
    searchLoading: dashboardMaintenanceSelectors.isLoading(state),
    currentUser: {
        id: staffSelectors.id(state) ? staffSelectors.id(state) : '',
        name: staffSelectors.name(state) ? staffSelectors.name(state) : ''
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
        changeOperationMode: operationActions.changeOperationMode,
        changeSelectedRecord: dashboardMaintenanceActions.setSelected,
        searchById: dashboardMaintenanceActions.searchById,
        search: dashboardMaintenanceActions.search,
        resetForm: () => reset(FORM_NAME),
        touchFormFields: (...args: any) => touch(FORM_NAME, ...args),
        untouchFormFields: (...args: any) => untouch(FORM_NAME, ...args),
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DashboardDetails);
